/* ── MM Shared Prefetch — Single API call for all widgets ── */
(function() {
  if (window.__mmPrefetch) return; // Already loaded

  // Diagnostic logging is opt-in (?mm_debug=1). Unconditional logging exposed the
  // full offers payload in every visitor's console and cost time on slow phones.
  function mmDebugLog() {
    try {
      var on = /[?&]mm_debug=1(?:&|$)/.test(window.location.search) ||
        (window.MMCompat && window.MMCompat.storage && window.MMCompat.storage.get('mm_debug') === '1');
      if (on && window.console && console.log) console.log.apply(console, arguments);
    } catch (e) {}
  }

  var cache = {
    offers: null,
    offerResponses: {},
    products: {},
    _offerPromises: {},
    _productPromises: {}
  };

  var LS_PREFIX = 'mm_offers_v2_';
  var LS_TTL_FRESH_MS = 2 * 60 * 1000;
  var LS_TTL_MAX_MS = 5 * 60 * 1000;

  function shopKey() {
    return (window.Shopify && window.Shopify.shop) || window.location.hostname || 'default';
  }

  function marketCountry() {
    if (window.MMOffers && typeof window.MMOffers.marketCountry === "function") return window.MMOffers.marketCountry();
    var host = document.body || document.documentElement;
    var country = host && host.getAttribute ? host.getAttribute("data-mm-country") : "";
    if (!country && document.documentElement.getAttribute) country = document.documentElement.getAttribute("data-mm-country") || "";
    return String(country || "BH").trim().toUpperCase() || "BH";
  }

  function offersCacheKey(handle) {
    return (handle ? ('product_' + handle) : '__all__') + '_' + marketCountry();
  }

  function lsStorageKey(apiKey) {
    return LS_PREFIX + shopKey() + '_' + apiKey;
  }

  function readOffersSnapshot(handle) {
    var apiKey = offersCacheKey(handle);
    var mem = cache.offerResponses[apiKey];
    if (mem && mem._ok) return mem;
    if (!handle && cache.offers && cache.offers._ok) return cache.offers;
    if (window.__mmOffersBootstrap && Array.isArray(window.__mmOffersBootstrap.offers) && !handle) {
      return normalizeOffersData(window.__mmOffersBootstrap);
    }
    try {
      var raw = localStorage.getItem(lsStorageKey(apiKey));
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.ts || !parsed.data) return null;
      var age = Date.now() - parsed.ts;
      if (age > LS_TTL_MAX_MS) {
        localStorage.removeItem(lsStorageKey(apiKey));
        return null;
      }
      var norm = normalizeOffersData(parsed.data);
      if (!norm) return null;
      norm._fromCache = true;
      norm._cacheAge = age;
      return norm;
    } catch (e) {
      return null;
    }
  }

  function writeOffersSnapshot(handle, data) {
    if (!data || !data._ok) return;
    try {
      var apiKey = offersCacheKey(handle);
      localStorage.setItem(lsStorageKey(apiKey), JSON.stringify({
        ts: Date.now(),
        data: { offers: data.offers, settings: data.settings || {} }
      }));
    } catch (e) { /* quota / private mode */ }
  }

  function applyOffersMemory(handle, norm) {
    var key = offersCacheKey(handle);
    cache.offerResponses[key] = norm;
    if (key === '__all__') cache.offers = norm;
  }

  function notifyOffersUpdated(handle, norm) {
    try {
      window.dispatchEvent(new CustomEvent('mm:offers-updated', {
        detail: { handle: handle || null, data: norm }
      }));
    } catch (e) { /* ignore */ }
  }

  function revalidateOffers(url, handle) {
    var key = offersCacheKey(handle);
    var flightKey = key + '__revalidate';
    if (cache._offerPromises[flightKey]) return cache._offerPromises[flightKey];
    cache._offerPromises[flightKey] = fetchOffersDirect(url, handle, 0, true)
      .finally(function () { delete cache._offerPromises[flightKey]; });
    return cache._offerPromises[flightKey];
  }

  // Get product handle from URL or data attributes
  function getHandle() {
    // Try data attributes first
    var el = document.querySelector("[data-mm-bundle-block], [data-mm-bogo-block], [data-mm-volume-block]");
    if (el && el.dataset.productHandle) return el.dataset.productHandle;
    // Fallback: URL
    var parts = window.location.pathname.split("/");
    var idx = parts.indexOf("products");
    return idx >= 0 ? parts[idx + 1] : null;
  }

  function normalizeOffersData(data) {
    if (!data || !Array.isArray(data.offers)) return null;
    if (!data.settings) data.settings = {};
    data._ok = true;
    return data;
  }

  function fetchOffersDirect(url, handle, attempt, isBackground) {
    attempt = attempt || 0;
    var key = offersCacheKey(handle);
    return fetch(url)
      .then(function(r) {
        if (!r.ok) throw new Error("offers HTTP " + r.status);
        return r.json();
      })
      .then(function(data) {
        var norm = normalizeOffersData(data);
        if (!norm) throw new Error("invalid offers payload");
        applyOffersMemory(handle, norm);
        writeOffersSnapshot(handle, norm);
        if (isBackground) notifyOffersUpdated(handle, norm);
        return norm;
      })
      .catch(function(err) {
        if (isBackground) {
          console.warn("[MM Prefetch] offers revalidate failed:", key, err);
          return readOffersSnapshot(handle) || { offers: [], settings: {}, _ok: false };
        }
        console.warn("[MM Prefetch] fetchOffers failed:", key, attempt, err);
        if (attempt < 1) {
          return new Promise(function(resolve) {
            setTimeout(resolve, 900);
          }).then(function() {
            return fetchOffersDirect(url, handle, attempt + 1, false);
          });
        }
        var stale = readOffersSnapshot(handle);
        if (stale && stale._ok) return stale;
        return { offers: [], settings: {}, _ok: false };
      });
  }

  // Fetch offers (memory + localStorage + network; stale-while-revalidate)
  function fetchOffers(handle) {
    var key = offersCacheKey(handle);
    var cached = cache.offerResponses[key];
    if (cached && cached._ok) return Promise.resolve(cached);

    if (cache._offerPromises[key]) return cache._offerPromises[key];

    var url = window.MMOffers && typeof window.MMOffers.offersApiUrl === "function"
      ? window.MMOffers.offersApiUrl(handle ? { productHandle: handle } : {})
      : "/apps/mm-app/api/offers?country=" + encodeURIComponent(marketCountry()) + (handle ? "&productHandle=" + encodeURIComponent(handle) : "");

    var snapshot = readOffersSnapshot(handle);
    if (snapshot && snapshot._ok) {
      applyOffersMemory(handle, snapshot);
      if ((snapshot._cacheAge || 0) > LS_TTL_FRESH_MS) {
        revalidateOffers(url, handle);
      }
      return Promise.resolve(snapshot);
    }

    // Global list: one flight via bridge preload (avoids duplicate slow API calls)
    if (!handle && window.__mmOffersPreload) {
      cache._offerPromises[key] = window.__mmOffersPreload
        .then(function(data) {
          var norm = normalizeOffersData(data);
          if (!norm) throw new Error("preload invalid");
          applyOffersMemory(handle, norm);
          writeOffersSnapshot(handle, norm);
          return norm;
        })
        .catch(function() {
          delete cache._offerPromises[key];
          cache._offerPromises[key] = fetchOffersDirect(url, handle, 0, false);
          return cache._offerPromises[key];
        });
      return cache._offerPromises[key];
    }

    cache._offerPromises[key] = fetchOffersDirect(url, handle, 0, false);
    return cache._offerPromises[key];
  }

  // Fetch product (cached)
  function fetchProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (cache.products[handle]) return Promise.resolve(cache.products[handle]);
    if (!cache._productPromises[handle]) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      var url = root + "products/" + handle + ".js";
      url = url.replace("//", "/");
      cache._productPromises[handle] = fetch(url)
        .then(function(r) { return r.ok ? r.json() : null; })
        .then(function(p) { if (p) cache.products[handle] = p; return p; })
        .catch(function() { return null; });
    }
    return cache._productPromises[handle];
  }

  // Fetch multiple products in parallel (cached)
  function fetchProducts(handles) {
    return Promise.all(handles.map(fetchProduct));
  }

  window.__mmPrefetch = {
    fetchOffers: fetchOffers,
    fetchProduct: fetchProduct,
    fetchProducts: fetchProducts,
    readOffersSnapshot: readOffersSnapshot,
    cache: cache
  };

  function safeParse(raw, fallback) {
    try { return JSON.parse(raw || "[]"); } catch(e) { return fallback || []; }
  }

  function productConfigMatches(config, handle) {
    if (!config || !handle) return false;
    if (config.handle === handle) return true;
    var opts = config.options || config.alternatives || [];
    if (Array.isArray(opts)) {
      for (var i = 0; i < opts.length; i++) {
        if (opts[i] && opts[i].handle === handle) return true;
      }
    }
    return false;
  }

  function offerMatchesHandle(offer, handle) {
    if (!offer || !handle) return false;
    var triggers = safeParse(offer.triggerProducts, []);
    var targets = safeParse(offer.targetProducts, []);
    if (triggers.indexOf(handle) > -1 || targets.indexOf(handle) > -1) return true;

    var cfg = safeParse(offer.bundleItemsConfig, offer.type === "BOGO" ? {} : []);
    if (Array.isArray(cfg)) {
      for (var i = 0; i < cfg.length; i++) {
        if (productConfigMatches(cfg[i], handle)) return true;
      }
    } else if (cfg && typeof cfg === "object") {
      if (productConfigMatches(cfg.trigger, handle) || productConfigMatches(cfg.target, handle)) return true;
    }
    return false;
  }

  function popupOffersForHandle(offers, handle) {
    var seen = {};
    var filtered = [];
    for (var i = 0; i < (offers || []).length; i++) {
      var offer = offers[i];
      if (!offerMatchesHandle(offer, handle)) continue;
      var key = String(offer.id || "") + "|" + String(offer.type || "");
      if (seen[key]) continue;
      seen[key] = 1;
      filtered.push(offer);
    }
    return filtered;
  }

  // ── Product Offer Popup Trigger ──
  function checkProductPopup(handle, data) {
    if (window.MM_THEME_OFFERS && window.MM_THEME_OFFERS.popup === false) {
      return;
    }
    mmDebugLog("[MM Popup Debug] checkProductPopup initialized for handle:", handle);
    mmDebugLog("[MM Popup Debug] data received from API:", data);
    
    if (!handle || !data || !data.offers || !data.offers.length) {
      mmDebugLog("[MM Popup Debug] Exit: Missing handle, data or active offers list");
      return;
    }
    
    var urlParams = new URLSearchParams(window.location.search);
    var ref = urlParams.get("mm_ref");
    
    var offers = popupOffersForHandle(data.offers, handle);
    mmDebugLog("[MM Popup Debug] Matched offers for handle:", offers);
    if (!offers.length) {
      mmDebugLog("[MM Popup Debug] Exit: No matching offers found for this product handle");
      return;
    }

    var settings = data.settings || {};
    var themeConfig = {};
    try { themeConfig = JSON.parse(settings.shopifyDealsConfig || "{}"); } catch(e) {}

    var popupEnabled = themeConfig.popupEnabled !== false;
    if (!popupEnabled) {
      mmDebugLog("[MM Popup Debug] Exit: Popup is disabled in admin settings");
      return;
    }

    var popupLimit = themeConfig.popupLimit !== undefined ? parseInt(themeConfig.popupLimit, 10) : 1;
    var shownCount = parseInt(sessionStorage.getItem("mm_popup_shown_count_" + handle) || "0", 10);
    var shouldAutoShow = popupLimit === 0 || shownCount < popupLimit;

    mmDebugLog("[MM Popup Debug] popupLimit:", popupLimit, "shownCount:", shownCount, "shouldAutoShow:", shouldAutoShow);

    var ar = (window.Shopify && window.Shopify.locale || "").indexOf("ar") === 0;
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "BHD";

    var triggerPopup = function() {
      // Create Overlay
      var ov = document.createElement("div");
      ov.className = "mm-offer-popup-overlay";
      if (themeConfig.eidThemeEnabled) ov.classList.add("mm-eid-theme");
      document.body.appendChild(ov);

      function close() {
        ov.classList.remove("open");
        setTimeout(function() { if (ov.parentNode) document.body.removeChild(ov); }, 500);
      }

      function fmtPop(cents) {
        var tax = parseFloat(settings.taxPercentage || 10) / 100;
        var total = cents * (1 + tax);
        var dec = (currency === "BHD" || currency === "KWD" || currency === "OMR") ? 3 : 2;
        var amt = (total / 100).toFixed(dec);
        if (ar) {
          var sym = "د.ب";
          if (currency === "SAR") sym = "ر.س";
          else if (currency === "AED") sym = "د.إ";
          return amt + " " + sym;
        }
        return amt + " " + currency;
      }

    function showStage1() {
      var cardsHtml = "";
      offers.forEach(function(o) {
        var title = ar ? (o.titleAr || o.title) : o.title;
        var typeNames = { BUNDLE: ar ? "باقة" : "Bundle", BOGO: "BOGO", VOLUME: ar ? "خصم كمية" : "Volume", DISCOUNTED_PRODUCT: ar ? "عرض" : "Deal" };
        var badgeText = typeNames[o.type] || "";
        
        var img = "";
        try {
          if (o.images) {
             var parsed = JSON.parse(o.images);
             if (Array.isArray(parsed) && parsed.length) img = parsed[0];
             else if (typeof parsed === 'string') img = parsed;
          }
        } catch(e) {
          if (typeof o.images === 'string' && o.images.indexOf('http') === 0) img = o.images;
        }

        if (!img) {
          if (window.Shopify && window.Shopify.product && window.Shopify.product.featured_image) {
            img = window.Shopify.product.featured_image;
          } else {
            var ogImg = document.querySelector('meta[property="og:image"]');
            if (ogImg) img = ogImg.content;
            else {
               var firstImg = document.querySelector('img[src*="/products/"], img[src*="/products_"]');
               if (firstImg) img = firstImg.src;
            }
          }
        }
        if (img && img.indexOf('//') === 0) img = 'https:' + img;

        var detail = "";
        if (o.type === "BOGO") {
          var ds = {}; try { ds = JSON.parse(o.displaySettings || "{}"); } catch(e){}
          var b = ds.bogoQtyBuy || 2, g = ds.bogoQtyGet || 1;
          detail = ar ? ("اشتري " + b + " واحصل على " + g + " مجاناً") : ("Buy " + b + " Get " + g + " FREE");
        } else if (o.type === "VOLUME") {
          try {
            var tiers = JSON.parse(o.volumeTiers || "[]");
            var max = 0;
            tiers.forEach(function(t) { if (t.discount > max) max = t.discount; });
            detail = ar ? ("خصم يصل إلى " + Math.round(max) + "%") : ("Up to " + Math.round(max) + "% OFF");
          } catch(e){}
        } else if (o.discountValue > 0) {
          detail = o.discountType === "PERCENTAGE" ? (o.discountValue + "% OFF") : "";
        }

        var meta = "";
        if (o.endsAt) {
          var left = new Date(o.endsAt).getTime() - Date.now();
          if (left > 0) {
            var h = Math.floor(left / 36e5);
            meta += '<span class="mm-pop-meta-item">⏱ ' + (ar ? "ينتهي خلال " : "Ends in ") + h + (ar ? " ساعة" : "h") + '</span>';
          }
        }
        if (o.customerQuantity > 0) {
          meta += '<span class="mm-pop-meta-item">🔥 ' + (ar ? "بقي " : "") + o.customerQuantity + (ar ? " فقط" : " left") + '</span>';
        }

        cardsHtml += '<div class="mm-pop-offer-card" style="cursor:pointer">' +
          (img ? '<img src="' + img + '" class="mm-pop-offer-img">' : '<div class="mm-pop-offer-img" style="background:#e2e8f0"></div>') +
          '<div class="mm-pop-offer-info">' +
            '<div class="mm-pop-offer-name">' + title + '</div>' +
            (detail ? '<div class="mm-pop-offer-desc">' + detail + '</div>' : '') +
            (meta ? '<div class="mm-pop-meta">' + meta + '</div>' : '') +
            '<div class="mm-pop-offer-badge">' + badgeText + '</div>' +
          '</div>' +
          '<button class="mm-pop-card-claim-btn">' + (ar ? "تفعيل العرض" : "Claim Offer") + '</button>' +
        '</div>';
      });

      ov.innerHTML = '<div class="mm-offer-popup">' +
        '<div class="mm-offer-popup-header">' +
          '<button class="mm-offer-popup-close">&times;</button>' +
          '<div class="mm-offer-popup-title">' + (ar ? "عرض خاص لك!" : "Special Offer for You!") + '</div>' +
          '<div class="mm-offer-popup-sub">' + (ar ? "متوفر الآن على هذا المنتج" : "Available now on this product") + '</div>' +
        '</div>' +
        '<div class="mm-offer-popup-body">' + cardsHtml + '</div>' +
        '<div class="mm-offer-popup-footer" style="display:none"></div>' +
      '</div>';

      ov.querySelector(".mm-offer-popup-close").onclick = close;
      var cardsList = ov.querySelectorAll(".mm-pop-offer-card");
      for (var ci = 0; ci < cardsList.length; ci++) {
        (function(card, idx) {
          card.onclick = function() { openStage2(offers[idx]); };
        })(cardsList[ci], ci);
      }
    }

    async function openStage2(offer) {
      var popup = ov.querySelector(".mm-offer-popup");
      var titleEl = popup.querySelector(".mm-offer-popup-title");
      var subEl = popup.querySelector(".mm-offer-popup-sub");
      var body = popup.querySelector(".mm-offer-popup-body");
      var footer = popup.querySelector(".mm-offer-popup-footer");

      footer.style.display = "block";

      // Set header for Stage 2
      titleEl.innerHTML = '<button class="mm-pop-back-btn" style="background:none;border:none;color:#fff;cursor:pointer;font-size:1.1rem;margin-inline-end:8px;padding:0">←</button>' + (ar ? (offer.titleAr || offer.title) : offer.title);
      subEl.textContent = ar ? "اختر الخيارات المفضلّة" : "Select your preferences";

      popup.querySelector(".mm-pop-back-btn").onclick = function() {
        showStage1();
      };

      body.innerHTML = '<div style="text-align:center;padding:40px;opacity:0.6">' + (ar ? "جاري تحميل الخيارات..." : "Loading options...") + '</div>';
      footer.innerHTML = "";

      // Load products
      var items = [];
      var bogoQtyBuy = 2, bogoQtyGet = 1;

      if (offer.type === "BUNDLE") {
        var cfg = [];
        try { cfg = JSON.parse(offer.bundleItemsConfig || "[]"); } catch(e) {}
        if (!cfg.length) {
          var triggers = [];
          try { triggers = JSON.parse(offer.triggerProducts || "[]"); } catch(e) {}
          cfg = triggers.map(function(h) { return { handle: h }; });
        }
        cfg.forEach(function(c) {
          if (c && c.type === "choice_group" && c.options && c.options.length) {
            items.push({ config: c, options: c.options, isChoice: true, qty: c.quantity || 1 });
          } else if (c && c.handle) {
            items.push({ config: c, handle: c.handle, isChoice: false, qty: c.quantity || 1 });
          }
        });
      } else if (offer.type === "BOGO") {
        var bogoConfig = {};
        try { bogoConfig = JSON.parse(offer.bundleItemsConfig || "{}"); } catch(e) {}
        var ds = {};
        try { ds = JSON.parse(offer.displaySettings || "{}"); } catch(e) {}
        bogoQtyBuy = ds.bogoQtyBuy || 2;
        bogoQtyGet = ds.bogoQtyGet || 1;
        
        var triggerItem = bogoConfig.trigger;
        var targetItem = bogoConfig.target;
        
        if (!triggerItem || !targetItem) {
          var trigs = [];
          var tgts = [];
          try { trigs = JSON.parse(offer.triggerProducts || "[]"); } catch(e) {}
          try { tgts = JSON.parse(offer.targetProducts || "[]"); } catch(e) {}
          triggerItem = { handle: trigs[0] || handle };
          targetItem = { handle: tgts[0] || trigs[0] || handle };
        }
        
        items.push({ config: triggerItem, handle: triggerItem.handle, qty: bogoQtyBuy, isTrigger: true });
        if (targetItem.type === "choice_group" && targetItem.options && targetItem.options.length) {
          items.push({ config: targetItem, options: targetItem.options, qty: bogoQtyGet, isTarget: true, isChoice: true });
        } else {
          items.push({ config: targetItem, handle: targetItem.handle, qty: bogoQtyGet, isTarget: true });
        }
      } else if (offer.type === "VOLUME") {
        items.push({ handle: handle, qty: 1, isVolume: true });
      } else {
        var cfg = [];
        try { cfg = JSON.parse(offer.bundleItemsConfig || "[]"); } catch(e) {}
        var h = (cfg[0] && cfg[0].handle) || handle;
        items.push({ handle: h, qty: 1 });
      }

      // Fetch products in parallel
      for (var idx = 0; idx < items.length; idx++) {
        var it = items[idx];
        if (it.isChoice) {
          it.products = await Promise.all(it.options.map(function(opt) { return fetchProduct(opt.handle); }));
          it.products = it.products.filter(Boolean);
          it.selectedProduct = it.products[0];
          it.selectedOption = it.options[0];
        } else {
          it.product = await fetchProduct(it.handle);
        }
      }

      // Render items list
      var html = "";
      items.forEach(function(it, idx) {
        var isBogo = offer.type === "BOGO";
        var bogoBadge = "";
        if (isBogo) {
          var qty = idx === 0 ? bogoQtyBuy : bogoQtyGet;
          if (idx === 0) {
            bogoBadge = '<span style="background:#e2e8f0;color:#334155;padding:2px 6px;border-radius:4px;font-size:0.7rem;font-weight:bold;margin-inline-end:6px">' + (ar ? "اشتري " : "BUY ") + qty + '</span>';
          } else {
            bogoBadge = '<span style="background:#fef2f2;color:#ef4444;padding:2px 6px;border-radius:4px;font-size:0.7rem;font-weight:bold;margin-inline-end:6px">' + (ar ? "احصل على " : "GET ") + qty + " " + (ar ? "مجاناً" : "FREE") + '</span>';
          }
        }

        var p = it.isChoice ? it.selectedProduct : it.product;
        if (!p) return;

        var choiceSelector = "";
        if (it.isChoice) {
          choiceSelector = '<select class="mm-pop-choice-sel" data-idx="' + idx + '" style="width:100%;padding:6px;border-radius:8px;border:1px solid #cbd5e1;font-size:0.8rem;font-weight:600;margin-bottom:6px;background:#fff">' +
            it.products.map(function(cp, cpIdx) { return '<option value="' + cpIdx + '">' + cp.title + '</option>'; }).join("") +
            '</select>';
        }

        var varSelector = "";
        var variants = p.variants || [];
        var activeConfig = it.isChoice ? it.selectedOption : it.config;
        if (activeConfig && activeConfig.variantMode === "specific") {
          var validIds = (activeConfig.selectedVariantIds || []).map(function(id) { return String(id).split("/").pop(); });
          if (validIds.length) {
            variants = variants.filter(function(v) { return validIds.indexOf(String(v.id)) > -1; });
          }
        }
        if (!variants.length) variants = p.variants || [];

        // Save selected variant back to item state
        it.selectedVariant = variants[0];
        it.availableVariants = variants;

        if (variants.length > 1) {
          varSelector = '<select class="mm-pop-variant-sel" data-idx="' + idx + '" style="width:100%;padding:6px;border-radius:8px;border:1px solid #cbd5e1;font-size:0.8rem;font-weight:600;background:#fff">' +
            variants.map(function(v) { return '<option value="' + v.id + '">' + v.title + '</option>'; }).join("") +
            '</select>';
        } else if (variants[0] && variants[0].title !== "Default Title") {
          varSelector = '<div style="font-size:0.8rem;color:#64748b;font-weight:600">' + variants[0].title + '</div>';
        }

        html += '<div class="mm-pop-stage2-row" data-idx="' + idx + '" style="display:flex;gap:12px;margin-bottom:12px;align-items:center;background:#f8fafc;padding:12px;border-radius:12px;border:1px solid #e2e8f0">' +
          '<img src="' + p.featured_image + '" class="mm-pop-stage2-img" style="width:50px;height:50px;border-radius:8px;object-fit:cover;background:#fff">' +
          '<div style="flex:1;min-width:0">' +
            '<div style="font-weight:700;font-size:0.85rem;color:#1e293b;margin-bottom:4px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">' + bogoBadge + p.title + '</div>' +
            choiceSelector +
            '<div class="mm-pop-variant-slot" data-idx="' + idx + '">' + varSelector + '</div>' +
          '</div>' +
        '</div>';
      });

      // Volume tiers block if VOLUME offer
      var volumeTierSelector = "";
      var selectedVolumeTier = null;
      if (offer.type === "VOLUME") {
        var tiers = [];
        try { tiers = JSON.parse(offer.volumeTiers || "[]"); } catch(e) {}
        tiers.sort(function(a, b) { return a.qty - b.qty; });
        if (tiers.length) {
          selectedVolumeTier = tiers[0];
          volumeTierSelector = '<div style="margin-bottom:12px">' +
            '<div style="font-size:0.75rem;font-weight:800;color:#64748b;text-transform:uppercase;margin-bottom:6px">' + (ar ? "اختر الكمية" : "Select Quantity") + '</div>' +
            '<select class="mm-pop-volume-tier-sel" style="width:100%;padding:8px;border-radius:8px;border:1px solid #cbd5e1;font-size:0.85rem;font-weight:700;background:#fff">' +
              tiers.map(function(t, tIdx) {
                var lbl = t.qty + " " + (ar ? "قطع" : "Units") + " (" + (offer.discountType === "PERCENTAGE" ? (t.discount + "% OFF") : fmtPop(t.discount * 100)) + ")";
                return '<option value="' + tIdx + '">' + lbl + '</option>';
              }).join("") +
            '</select>' +
          '</div>';
        }
      }

      body.innerHTML = volumeTierSelector + '<div style="display:flex;flex-direction:column">' + html + '</div>';

      // Footer price summary & button
      footer.innerHTML = '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;padding:0 4px">' +
        '<div style="text-align:start">' +
          '<span style="text-decoration:line-through;color:#94a3b8;font-size:0.8rem;margin-inline-end:6px;display:none" id="mm-pop-price-old"></span>' +
          '<div style="font-weight:900;font-size:1.15rem;color:#1e293b" id="mm-pop-price-new"></div>' +
        '</div>' +
        '<span style="background:#10b981;color:#fff;font-size:0.75rem;font-weight:800;padding:4px 8px;border-radius:6px;display:none" id="mm-pop-savings"></span>' +
      '</div>' +
      '<button class="mm-pop-atc-btn" style="width:100%;background:#ef4444;color:#fff;border:none;padding:14px;border-radius:50px;font-weight:800;font-size:0.95rem;cursor:pointer;box-shadow:0 4px 12px rgba(239,68,68,0.2);transition:all 0.2s">' +
        (ar ? "أضف للسلة" : "Add to Cart") +
      '</button>';

      // Update price display helper
      function updateStage2Price() {
        var total = 0, disc = 0;
        
        if (offer.type === "BOGO") {
          var trigItem = items[0];
          var tgtItem = items[1];
          
          var trigPrice = (trigItem && trigItem.selectedVariant) ? trigItem.selectedVariant.price : 0;
          var tgtPrice = (tgtItem && tgtItem.selectedVariant) ? tgtItem.selectedVariant.price : trigPrice;
          
          total = (trigPrice * bogoQtyBuy) + (tgtPrice * bogoQtyGet);
          disc = tgtPrice * bogoQtyGet;
        } else if (offer.type === "VOLUME") {
          var it = items[0];
          var base = (it && it.selectedVariant) ? it.selectedVariant.price : 0;
          var qty = selectedVolumeTier ? selectedVolumeTier.qty : 1;
          var dVal = selectedVolumeTier ? parseFloat(selectedVolumeTier.discount) : 0;
          
          total = base * qty;
          disc = offer.discountType === "PERCENTAGE" 
            ? Math.round(total * (dVal / 100)) 
            : Math.round(dVal * 100);
        } else if (offer.type === "BUNDLE") {
          items.forEach(function(it) {
            if (!it.selectedVariant) return;
            var q = it.qty || 1;
            total += it.selectedVariant.price * q;
          });

          var mode = offer.discountMode || "OVERALL";
          var type = offer.discountType || "PERCENTAGE";
          var val  = parseFloat(offer.discountValue) || 0;

          if (mode === "PER_PRODUCT") {
            items.forEach(function(it) {
              if (!it.selectedVariant) return;
              var q = it.qty || 1;
              var activeConfig = it.isChoice ? it.selectedOption : it.config;
              var pDisc = parseFloat(activeConfig.discount || 0) / 100;
              disc += Math.round(it.selectedVariant.price * pDisc) * q;
            });
          } else {
            if (type === "PERCENTAGE") disc = Math.round(total * (val / 100));
            else if (type === "FIXED_EACH") {
              var count = 0;
              items.forEach(function(it) { count += it.qty || 1; });
              disc = (val * 100) * count;
            } else {
              disc = val * 100;
            }
          }
        } else {
          // Global Deal
          var it = items[0];
          if (it && it.selectedVariant) {
            var compare = parseFloat(it.selectedVariant.compare_at_price || it.selectedVariant.compareAtPrice || 0);
            var nowPrice = it.selectedVariant.price;
            if (compare > nowPrice) {
              total = compare;
              disc = compare - nowPrice;
            } else {
              total = nowPrice;
              disc = 0;
            }
          }
        }

        var finalPrice = Math.max(0, total - disc);
        var oldEl = footer.querySelector("#mm-pop-price-old");
        var newEl = footer.querySelector("#mm-pop-price-new");
        var savEl = footer.querySelector("#mm-pop-savings");

        newEl.textContent = fmtPop(finalPrice);
        if (disc > 0) {
          oldEl.textContent = fmtPop(total);
          oldEl.style.display = "inline";
          var pct = Math.round((disc / total) * 100);
          savEl.textContent = (ar ? "وفر " : "Save ") + pct + "%";
          savEl.style.display = "inline";
        } else {
          oldEl.style.display = "none";
          savEl.style.display = "none";
        }
      }

      // Attach choice listeners
      body.querySelectorAll(".mm-pop-choice-sel").forEach(function(sel) {
        sel.addEventListener("change", function() {
          var itemIdx = parseInt(this.dataset.idx);
          var cpIdx = parseInt(this.value);
          var it = items[itemIdx];
          it.selectedProduct = it.products[cpIdx];
          it.selectedOption = it.options[cpIdx];

          // Re-render variants for this slot
          var variants = it.selectedProduct.variants || [];
          if (it.selectedOption.variantMode === "specific") {
            var validIds = (it.selectedOption.selectedVariantIds || []).map(function(id) { return String(id).split("/").pop(); });
            if (validIds.length) {
              variants = variants.filter(function(v) { return validIds.indexOf(String(v.id)) > -1; });
            }
          }
          if (!variants.length) variants = it.selectedProduct.variants || [];
          it.selectedVariant = variants[0];
          it.availableVariants = variants;

          var slot = body.querySelector('.mm-pop-variant-slot[data-idx="' + itemIdx + '"]');
          if (variants.length > 1) {
            slot.innerHTML = '<select class="mm-pop-variant-sel" data-idx="' + itemIdx + '" style="width:100%;padding:6px;border-radius:8px;border:1px solid #cbd5e1;font-size:0.8rem;font-weight:600;background:#fff">' +
              variants.map(function(v) { return '<option value="' + v.id + '">' + v.title + '</option>'; }).join("") +
              '</select>';
            slot.querySelector("select").addEventListener("change", function() {
              var vId = parseInt(this.value);
              it.selectedVariant = it.availableVariants.find(function(v) { return v.id === vId; });
              
              var v = it.selectedVariant;
              if (v) {
                var imgUrl = (v.featured_image && v.featured_image.src) || it.selectedProduct.featured_image;
                var imgEl = body.querySelector('.mm-pop-stage2-row[data-idx="' + itemIdx + '"] img');
                if (imgEl && imgUrl) imgEl.src = imgUrl;
              }

              updateStage2Price();
            });
          } else {
            slot.innerHTML = variants[0] && variants[0].title !== "Default Title" ? '<div style="font-size:0.8rem;color:#64748b;font-weight:600">' + variants[0].title + '</div>' : '';
          }

          // Update image
          var imgEl = body.querySelector('.mm-pop-stage2-row[data-idx="' + itemIdx + '"] img');
          if (imgEl) {
            var v = it.selectedVariant;
            var imgUrl = (v && v.featured_image && v.featured_image.src) || it.selectedProduct.featured_image;
            imgEl.src = imgUrl || "";
          }

          updateStage2Price();
        });
      });

      // Attach variant listeners
      body.querySelectorAll(".mm-pop-variant-sel").forEach(function(sel) {
        sel.addEventListener("change", function() {
          var itemIdx = parseInt(this.dataset.idx);
          var vId = parseInt(this.value);
          var it = items[itemIdx];
          it.selectedVariant = it.availableVariants.find(function(v) { return v.id === vId; });
          
          var v = it.selectedVariant;
          if (v) {
            var imgUrl = (v.featured_image && v.featured_image.src) || it.selectedProduct.featured_image;
            var imgEl = body.querySelector('.mm-pop-stage2-row[data-idx="' + itemIdx + '"] img');
            if (imgEl && imgUrl) imgEl.src = imgUrl;
          }

          updateStage2Price();
        });
      });

      // Attach volume tier listeners
      var volTierSel = body.querySelector(".mm-pop-volume-tier-sel");
      if (volTierSel) {
        volTierSel.addEventListener("change", function() {
          var tiers = [];
          try { tiers = JSON.parse(offer.volumeTiers || "[]"); } catch(e) {}
          tiers.sort(function(a, b) { return a.qty - b.qty; });
          selectedVolumeTier = tiers[parseInt(this.value)];
          updateStage2Price();
        });
      }

      updateStage2Price();

      // Add to Cart Action
      footer.querySelector(".mm-pop-atc-btn").onclick = async function() {
        this.disabled = true;
        this.classList.add("mm-atc-busy");

        try {
          var lines = [];
          var bundleGroupId = "bg_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9);
          
          if (offer.type === "BOGO") {
            var trigVarId = items[0].selectedVariant.id;
            var freeVarId = items[1].selectedVariant.id;
            
            var props = {
              _offerId: offer.id,
              _offerType: "BOGO",
              _mmNoDiscountCodes: "true",
              _bundleGroupId: bundleGroupId
            };
            
            lines.push({ id: trigVarId, quantity: bogoQtyBuy, properties: props });
            if (String(freeVarId) === String(trigVarId)) {
              lines[0].quantity = bogoQtyBuy + bogoQtyGet;
            } else {
              lines.push({ id: freeVarId, quantity: bogoQtyGet, properties: props });
            }
          } else if (offer.type === "VOLUME") {
            var qty = selectedVolumeTier ? selectedVolumeTier.qty : 1;
            lines.push({
              id: items[0].selectedVariant.id,
              quantity: qty,
              properties: {
                _offerId: offer.id,
                _offerType: "VOLUME",
                _bundleGroupId: bundleGroupId
              }
            });
          } else {
            items.forEach(function(it) {
              if (!it.selectedVariant) return;
              lines.push({
                id: it.selectedVariant.id,
                quantity: it.qty || 1,
                properties: {
                  _offerId: offer.id,
                  _offerType: offer.type,
                  _bundleGroupId: bundleGroupId
                }
              });
            });
          }

          var addRes = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ items: lines })
          });
          if (!addRes.ok) throw new Error(await addRes.text());

          // Build attributes
          var newDeals = [];
          if (offer.type === "BOGO") {
            var trigVarId = items[0].selectedVariant.id;
            var freeVarId = items[1].selectedVariant.id;
            newDeals.push({
              variantId: String(freeVarId),
              isFreeGift: true,
              discountPercent: 100,
              type: "bogo",
              offerId: offer.id,
              freeQty: bogoQtyGet,
              triggerQty: bogoQtyBuy
            });
            if (String(trigVarId) !== String(freeVarId)) {
              newDeals.push({
                variantId: String(trigVarId),
                isFreeGift: false,
                type: "bogo_trigger",
                offerId: offer.id
              });
            }
          } else if (offer.type === "VOLUME") {
            var qty = selectedVolumeTier ? selectedVolumeTier.qty : 1;
            var dVal = selectedVolumeTier ? parseFloat(selectedVolumeTier.discount) : 0;
            newDeals.push({
              variantId: String(items[0].selectedVariant.id),
              type: "volume",
              offerId: offer.id,
              discountPercent: offer.discountType === "PERCENTAGE" ? dVal : 0,
              volumeQty: qty
            });
          } else if (offer.type === "BUNDLE") {
            function getBundlePct(it) {
              var activeConfig = it.isChoice ? it.selectedOption : it.config;
              if (offer.discountMode === "PER_PRODUCT") {
                var p = parseFloat(activeConfig.discount);
                if (!isNaN(p) && p > 0) return p;
              }
              return parseFloat(offer.discountValue) || 0;
            }
            items.forEach(function(it) {
              if (!it.selectedVariant) return;
              newDeals.push({
                variantId: String(it.selectedVariant.id),
                discountPercent: getBundlePct(it),
                type: "bundle",
                offerId: offer.id,
                quantity: it.qty || 1
              });
            });
          }

          var cart = await (await fetch("/cart.js")).json();
          var old = [];
          try { old = JSON.parse(cart.attributes._flash_deals_data || "[]"); } catch(e) {}
          var merged = (window.MMOffers && window.MMOffers.mergeOfferDeals)
            ? window.MMOffers.mergeOfferDeals(old, newDeals, offer.id)
            : old.filter(function(d) { return String(d.offerId) !== String(offer.id); }).concat(newDeals);

          var attributes = {
            _flash_deals_data: JSON.stringify(merged),
            _mm_country: window.MMOffers && window.MMOffers.marketCountry ? window.MMOffers.marketCountry() : "BH"
          };
          if (offer.type === "BOGO") {
            attributes._mm_has_bogo_offer = "true";
            attributes._mm_block_discount_codes = "true";
          }

          await fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ attributes: attributes })
          });

          this.classList.remove("mm-atc-busy");
          this.textContent = ar ? "تمت الإضافة!" : "Added!";
          var finalCart = await (await fetch("/cart.js")).json();
          if (window.MMOffers && window.MMOffers.openCartSheet) {
            await window.MMOffers.openCartSheet(finalCart);
          } else if (window.MMCart && window.MMCart.refresh) {
            var refreshed = await window.MMCart.refresh();
            if (window.MMCart.open) window.MMCart.open({ skipRefresh: true, cart: refreshed });
          }
          var btn = this;
          setTimeout(function () {
            btn.disabled = false;
            btn.classList.remove("mm-atc-busy");
            btn.textContent = ar ? "أضف للسلة" : "Add to Cart";
          }, 1600);
        } catch(e) {
          console.error("Popup ATC error:", e);
          this.disabled = false;
          this.classList.remove("mm-atc-busy");
          this.textContent = ar ? "أضف للسلة" : "Add to Cart";
        }
      };
    }

    showStage1();
    
    // Smooth reveal
    setTimeout(function() { ov.classList.add("open"); }, 100);

    ov.onclick = function(e) { if (e.target === ov) close(); };
  };

  // Render Floating Launcher Button (theme can disable)
  if (!(window.MM_THEME_OFFERS && window.MM_THEME_OFFERS.launcher === false)) {
  var launcher = document.createElement("button");
  launcher.className = "mm-popup-launcher";
  if (ar) launcher.classList.add("mm-rtl");
  if (themeConfig.eidThemeEnabled) launcher.classList.add("mm-eid-theme");
  
  var btnText = ar ? "عروض متوفرة ⚡" : "Active Offers ⚡";
  launcher.innerHTML = '<span class="mm-popup-launcher-icon">🎁</span><span class="mm-popup-launcher-text">' + btnText + '</span>';
  launcher.addEventListener("click", function() {
    triggerPopup();
  });
  document.body.appendChild(launcher);

  // Auto trigger if applicable
  if (shouldAutoShow) {
    sessionStorage.setItem("mm_popup_shown_count_" + handle, String(shownCount + 1));
    triggerPopup();
  }
  }
  }

  // Warm global offers cache (uses bridge preload when available)
  fetchOffers();

  var handle = getHandle();
  if (handle) {
    fetchOffers(handle).then(function(data) {
      // Check for popup trigger after data is loaded
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", function() { checkProductPopup(handle, data); });
      } else {
        checkProductPopup(handle, data);
      }
    });
  }

})();
